export default {
  namespaced: true,
  state: {
    session_id: '',
    tel: '',
    currentTab: '',
  },
  mutations: {
    setSessionId(state, data) {
      state.session_id = data
    },
    setTel(state, data) {
      state.tel = data.tel
      state.currentTab = data.currentTab
    },
  },
}
